<div>
    <app-dyn-list #dynList [data]="data" [showInGroups]="showInGroups" [rolePrefix]="rolePrefix"
        (isSubmitted)="isSubmitted.emit($event)" (isCanceled)="isCanceled.emit(true)" [directory]="directory">
    </app-dyn-list>
</div>